/**
 * BottomNavMore - "More" menu Sheet for mobile bottom navigation.
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { Sheet, SheetContent, SheetTitle } from '@/components/v2/ui/Sheet';
import { Palette, Shield, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';
interface BottomNavMoreProps {
  open: boolean;
  onClose: () => void;
}

export function BottomNavMore({ open, onClose }: BottomNavMoreProps) {
  const { t } = useTranslation();
  const { user } = useSupabaseAuth();

  const items = [
    { path: '/v2/templates', label: t('nav.templates'), icon: Palette },
    { path: '/v2/settings', label: t('nav.settings'), icon: Settings },
    ...(user?.is_admin ? [{ path: '/v2/admin', label: t('nav.admin'), icon: Shield, danger: true }] : []),
  ];

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="bottom" className="p-4 pb-20 rounded-t-xl bg-white dark:bg-neutral-900">
        <SheetTitle className="sr-only">{t('mobileNav.more')}</SheetTitle>
        <div className="space-y-1">
          {items.map(({ path, label, icon: Icon, danger }) => (
            <Link
              key={path}
              to={path}
              onClick={onClose}
              className={cn(
                'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                danger
                  ? 'text-red-700 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30'
                  : 'text-neutral-800 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-800'
              )}
            >
              <Icon className="h-5 w-5" />
              <span>{label}</span>
            </Link>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
